module.exports = __webpack_public_path__ + "aef919e021aab63e09df185e9c9b3c20.png";